// src/app/app-routing.module.ts
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {environment} from '../environments/environment';
import {oakvilleRoutes, muskokaRoutes} from './app-routing.config';

@NgModule({
  imports: [
    RouterModule.forRoot(
      environment.hostname.includes('oakville') ? oakvilleRoutes : muskokaRoutes,
      {
        enableTracing: false,
        initialNavigation: 'enabledBlocking',
        useHash: false
      }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
